module.exports = __webpack_public_path__ + "img/415426-1.1e189bda.png";